import { Injectable } from '@angular/core';
import { NetworkDeviceStateEvent } from '@ubie/mqttcommunication';
import { from, Observable, of, share, switchMap } from 'rxjs';
import { ObservableDictionary } from '../ObservableDictionary';
import { BaseCommunicationService } from './base-communication-service';

@Injectable({
  providedIn: 'root',
})
export class NetworkDeviceCommunicationService extends BaseCommunicationService<NetworkDeviceStateEvent> {
  readonly createNetworkDeviceItemFn = (
    key: string,
  ): Observable<NetworkDeviceStateEvent> => {
    const [ubieSerialNumber, networkDeviceSerialNumber] = key.split(
      this.KEY_SPLIT,
    );

    return this.communicationListenerService
      .getNetworkDeviceCommunicationOnly(
        ubieSerialNumber,
        networkDeviceSerialNumber,
      )
      .pipe(share());
  };

  readonly deleteNetworkDeviceItemFn = (key: string): void => {
    const [ubieSerialNumber, networkDeviceSerialNumber] = key.split(
      this.KEY_SPLIT,
    );

    this.communicationFilterService
      .disableNetworkDevices([
        {
          device: {
            serialNumber: ubieSerialNumber,
          },
          serialNumber: networkDeviceSerialNumber,
        },
      ])
      .then();
  };
  protected override readonly dictionary: ObservableDictionary<NetworkDeviceStateEvent> =
    new ObservableDictionary<NetworkDeviceStateEvent>(
      this.createNetworkDeviceItemFn,
      this.deleteNetworkDeviceItemFn,
    );

  enable(key: string): Observable<void> {
    const [ubieSerialNumber, networkDeviceSerialNumber] = key.split(
      this.KEY_SPLIT,
    );
    return from(
      this.communicationFilterService.enableNetworkDevices([
        {
          device: {
            serialNumber: ubieSerialNumber,
          },
          serialNumber: networkDeviceSerialNumber,
        },
      ]),
    ).pipe(switchMap(() => of()));
  }

  getOrAddItem(key: string): Observable<NetworkDeviceStateEvent> {
    return this.dictionary.getOrAdd(key);
  }
}
